import { render, staticRenderFns } from "./BestView.vue?vue&type=template&id=4cf6da7e&scoped=true"
import script from "./BestView.vue?vue&type=script&lang=js"
export * from "./BestView.vue?vue&type=script&lang=js"
import style0 from "./BestView.vue?vue&type=style&index=0&id=4cf6da7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf6da7e",
  null
  
)

export default component.exports